<template>
  <b-card>
    <b-row>
      <h6 class="mx-1 mb-2">
        {{ $t('Email preferences') }}
      </h6>
      <b-col
        cols="12"
        class="mb-2"
      >
        <b-form-checkbox
          id="noPub"
          v-model="nopub"
          name="check-button"
          switch
          inline
        >
          <span>{{ $t('No Advertising emails') }}</span>
        </b-form-checkbox>
      </b-col>
      <b-col
        cols="12"
        class="mb-2"
      >
        <b-form-checkbox
          id="noAlert"
          v-model="noalert"
          name="check-button"
          switch
          inline
        >
          <span>{{ $t('No alerts when someone starts to work on my order') }}</span>
        </b-form-checkbox>
      </b-col>
      <!-- buttons -->
      <b-col cols="12">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-1 mt-1"
          @click="saveEmailPreferences"
          :disabled="isloading"
        >
          <b-spinner small v-if="isloading"/>
          {{ $t('Save changes') }}
        </b-button>
      </b-col>
      <!--/ buttons -->
    </b-row>
  </b-card>
</template>

<script>
import Apicall from '@/libs/api-call'
import {
  BButton, BRow, BCol, BCard, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BFormCheckbox,
    BSpinner,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    notificationData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isloading: false,
      nopub: this.notificationData.nopub == 1 ? true : false,
      noalert: this.notificationData.noalert == 1 ? true : false,
    }
  },
  methods: {
    saveEmailPreferences() {
      const api = new Apicall();
        this.isloading = true;
        api.updateMyAccountNotification(this.nopub, this.noalert).then(response => {
          this.isloading = false;
          if (response.status === 'OK') { 
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                variant: 'success',
                title: this.$t('message.someFieldsUpdatedSuccess', {'_field_':this.$t('Email preferences')}),
                icon: 'CheckIcon'
              },
            });
          } else {
            if (response.statuscode === 401) this.$router.push('Login');
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                variant: 'danger',
                title: this.$t(response.msg),
                icon: 'XIcon',
              },
            });
          }
        });
    },
  },
}
</script>
